import { useMutation } from '@tanstack/react-query';

import type { BackendTypes } from '@tf/api';
import { BackendClient } from '@tf/api';
import { rawRevision } from '@tf/utils';

import { useInvalidateApplicationQueries } from './applications';

export const useConnectNewMutation = () => {
	const invalidateApplicationQueries = useInvalidateApplicationQueries();

	return useMutation({
		mutationFn: async ({
			parentEntityId,
			connectionKind,
			entityKind,
			selfSegmentData,
		}: {
			parentEntityId: BackendTypes.GraphId;
			connectionKind: BackendTypes.EntityConnectionKind;
			entityKind: BackendTypes.EntityKind;
			selfSegmentData: Record<string, any>;
		}): Promise<BackendTypes.EntityConnectNewData> => {
			const res = await BackendClient.getInstance().entityConnectNew(
				{ parentEntityId: parentEntityId, connectionKind: connectionKind, entityKind: entityKind },
				{
					listEntitySegments: [
						{
							revision: rawRevision,
							segmentIdentity: {
								// TODO:
								segmentKind: `${entityKind}__SELF`,
								graphId: -2,
							},
							segment: selfSegmentData,
						},
					],
					listConnectionSegments: [],
				},
			);
			return res.json();
		},
		onSuccess: () => {
			invalidateApplicationQueries();
		},
	});
};

export const useConnectExistingMutation = () => {
	const invalidateApplicationQueries = useInvalidateApplicationQueries();

	return useMutation({
		mutationFn: async ({
			parentEntityId,
			connectionKind,
			entityId,
		}: {
			parentEntityId: BackendTypes.GraphId;
			connectionKind: BackendTypes.EntityConnectionKind;
			entityId: BackendTypes.GraphId;
		}): Promise<BackendTypes.EntityConnectExistingData> => {
			const res = await BackendClient.getInstance().entityConnectExisting(
				{ parentEntityId: parentEntityId, connectionKind: connectionKind, entityId: entityId },
				[],
			);
			return res.json();
		},
		onSuccess: () => {
			invalidateApplicationQueries();
		},
	});
};

export const useDisconnectMutation = () => {
	const invalidateApplicationQueries = useInvalidateApplicationQueries();

	return useMutation({
		mutationFn: async ({
			parentEntityId,
			connectionKind,
			entityId,
		}: {
			parentEntityId: BackendTypes.GraphId;
			connectionKind: BackendTypes.EntityConnectionKind;
			entityId: BackendTypes.GraphId;
		}) => {
			const res = await BackendClient.getInstance().entityDisconnectEntity({
				parentEntityId: parentEntityId,
				connectionKind: connectionKind,
				entityId: entityId,
			});
			return res.json();
		},
		onSuccess: () => {
			invalidateApplicationQueries();
		},
	});
};
